import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { FloatingPortal } from '@floating-ui/react';
import 'react';
import 'tslib';
import 'lodash';
import 'lodash/includes';
import './TextField2.js';
import '@headlessui/react';
import '@ninja/icons/web';
import './common.js';
import './ThemeProvider2.js';
import { BottomSheet } from './DialogModal2.js';
import './DialogModal3.js';

const ResponsiveRenderViewContainer = ({ children, calendarViewStyles, calenderViewRef, getFloatingProps, isElementOutOfScope, isFocused, isMounted, onCalendarClose, setFloating, isMobile, enableTimeSelection, pickerViewMode = 'days', multiCalendar = false, isIntervalPicker, }) => {
    if (isMobile) {
        const getMobileHeight = () => {
            if (enableTimeSelection) {
                return isIntervalPicker ? '25rem' : '20rem';
            }
            return isIntervalPicker ? '20rem' : '17.5rem';
        };
        return (jsx(BottomSheet, { isOpen: isFocused, onClose: onCalendarClose, height: getMobileHeight(), children: children }));
    }
    const getHeight = () => {
        if (!isIntervalPicker) {
            if (enableTimeSelection) {
                return [multiCalendar ? 'h-[23.75rem]' : 'h-[23.125rem]'];
            }
            else if (pickerViewMode === 'time') {
                return [multiCalendar ? 'h-[21.25rem]' : 'h-[20.625rem]'];
            }
            else {
                return [multiCalendar ? 'h-[22.5rem]' : 'h-[20.625rem]'];
            }
        }
        else {
            return [enableTimeSelection ? 'h-[25rem]' : 'h-[23.125rem]'];
        }
    };
    return isMounted ? (jsx(FloatingPortal, { children: jsx("div", { ref: calenderViewRef, className: "sh-date-picker", children: jsx("div", Object.assign({ className: clsx('z-floating flex ', getHeight(), isElementOutOfScope && 'invisible'), ref: setFloating, style: calendarViewStyles }, getFloatingProps(), { children: jsxs("div", { className: "bg-white rounded-md shadow-datePicker !block w-min  p-4 ", children: [" ", children] }) })) }) })) : (jsx(Fragment, {}));
};

export { ResponsiveRenderViewContainer as default };
